import React from 'react';

import { get } from 'lodash';

import {
  DescriptionList,
  DescriptionItem,
  Link,
  Typography,
} from '@gogame/components';
import { rangePresets } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import {
  FILTER_PERIOD as INFLUENCERS_CAMPAIGNS_FILTER_PERIOD,
  FILTER_MASTER_CAMPAIGNS as INFLUENCERS_CAMPAIGNS_FILTER_MASTER_CAMPAIGNS,
} from 'scenes/Influencers/InfluencersCampaigns/constants';
import { influencersCampaignsLink } from 'scenes/Influencers/InfluencersCampaigns/navigation';
import { filtersSchema as influencersCampaignsFiltersSchema } from 'scenes/Influencers/InfluencersCampaigns/schemas';
import { FILTER_MASTER_CAMPAIGNS as INFLUENCERS_CHANNELS_FILTER_MASTER_CAMPAIGNS } from 'scenes/Influencers/InfluencersChannels/constants';
import { influencersChannelsLink } from 'scenes/Influencers/InfluencersChannels/navigation';
import { filtersSchema as influencersChannelsFiltersSchema } from 'scenes/Influencers/InfluencersChannels/schemas';

const BriefListItem = ({ attachmentUrl, name }) => (
  <Link href={attachmentUrl} target={'_blank'}>
    <Typography>{name}</Typography>
  </Link>
);

const GeneralSection = ({ data, onOpenPromoCode, id }) => {
  return (
    <DescriptionList data={data} disableGutters={true}>
      <DescriptionItem
        field={'startDate'}
        label={'Period'}
        type={'date'}
        template={'MONTH'}
        timeZone={'utc'}
      />
      <DescriptionItem field={'application.name'} label={'Application'} />
      <DescriptionItem field={'network.name'} label={'Network'} />
      <DescriptionItem
        label={'Platforms'}
        field={'platforms'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        field={'briefs'}
        label={'Briefs'}
        type={'typographyList'}
        unitsLabel={'Briefs'}
        limit={5}
        item={BriefListItem}
      />
      <DescriptionItem
        label={'Promo code'}
        field={'promoCode'}
        type={'link'}
        linkLabelField={'name'}
        onValueClick={onOpenPromoCode}
      />

      <DescriptionItem
        label={'Conversion page'}
        field={'conversionPage.name'}
        type={'link'}
        target={'_blank'}
        href={get(data, 'conversionPage.name')}
        style={{ wordBreak: 'break-word' }}
      />
      <DescriptionItem field={'description'} label={'Description'} />
      <DescriptionItem
        field={'influencerChannels'}
        label={'Influencer channels'}
        type={() => (
          <Typography>
            <ScreenLink
              link={influencersChannelsLink}
              params={{
                filters: {
                  ...influencersChannelsFiltersSchema.default(),
                  [INFLUENCERS_CHANNELS_FILTER_MASTER_CAMPAIGNS]: [id],
                },
                ready: true,
              }}
            >
              {`${data.influencerChannels.length} channels`}
            </ScreenLink>
          </Typography>
        )}
      />

      <DescriptionItem
        field={'influencerChannels'}
        label={'Influencer campaigns'}
        type={() => (
          <Typography>
            <ScreenLink
              link={influencersCampaignsLink}
              params={{
                filters: {
                  ...influencersCampaignsFiltersSchema.default(),
                  [INFLUENCERS_CAMPAIGNS_FILTER_PERIOD]:
                    rangePresets.LIFETIME_PLUS_FUTURE.value,
                  [INFLUENCERS_CAMPAIGNS_FILTER_MASTER_CAMPAIGNS]: [id],
                },
                ready: true,
              }}
            >
              {`${data.influencerCampaigns.length} campaigns`}
            </ScreenLink>
          </Typography>
        )}
      />
      <DescriptionItem
        label={'Attribute provider'}
        field={'attributionProvider.name'}
      />
    </DescriptionList>
  );
};

export default GeneralSection;
